export default "__VITE_ASSET__CN94y67A__"